export const DoubleAuthenticationModel = {
    NONE: 0,
    SMS: 1,
    GOOGLE_AUTHENTICATOR: 2,
    BOTH: 3,
    BACKUP_CODE: 4,
};
